import api from '../../utils/api';

// eslint-disable-next-line import/prefer-default-export
export const updateDoctor = async (id, payload) => {
	return api.put(`/doctors/${id}`, payload);
};
